import { NgModule } from '@angular/core';

import { SharedModule } from '../../../shared';
import { AtividadeFilterComponent } from './atividade-filter.component';
import { AtividadeFilterVisibilidadeComponent, AtividadeFilterVisibilidadePipe, AtividadeFilterVisibilidadeIconPipe } from './visibilidade';
import { MultiselectDropdownModule } from 'angular-2-dropdown-multiselect';

@NgModule({
    imports: [
        SharedModule,
        MultiselectDropdownModule
    ],
    declarations: [
        AtividadeFilterComponent,
        AtividadeFilterVisibilidadeComponent,
        AtividadeFilterVisibilidadePipe,
        AtividadeFilterVisibilidadeIconPipe
    ],
    exports: [
        AtividadeFilterComponent,
        AtividadeFilterVisibilidadeComponent,
        AtividadeFilterVisibilidadePipe,
        AtividadeFilterVisibilidadeIconPipe
    ],
    providers: [
        AtividadeFilterVisibilidadePipe,
        AtividadeFilterVisibilidadeIconPipe
    ]
})
export class AtividadeFilterModule { }
